import React, { PureComponent } from 'react';
import _ from 'lodash';
import { Link } from 'react-router-dom';
import { WithTitle, Slider, BackgroundImage } from '.';
import { withRedux } from '../hoc';
import { getServiceUrl } from '../utils';

const TIPSTRENDS_ID = _.toInteger(process.env.REACT_APP_TIPSTRENDS_ID);

const mapStateToProps = state => {
  return {
    t: _.get(state, 't'),
    languages: _.get(state, 'languages'),
    post: _.get(state, 'post')
  };
};

const actions = {};

@withRedux(mapStateToProps, actions)
export default class PopularTipsTrends extends PureComponent {
  getData = () => {
    const { t } = this.props;
    let datas = _.get(this.props, 'post.posts.data');
    if (_.isEmpty(datas)) return datas;
    datas = _.filter(datas, data => {
      return t(data.popular) === true && data.post_category_id === TIPSTRENDS_ID;
    });
    datas = _.orderBy(datas, ['created_at', 'updated_at'], ['desc', 'desc']);
    return datas;
  };
  render() {
    const { t } = this.props;
    const datas = this.getData();
    if (_.size(datas) === 0) return null;
    return (
      <div className="popular-tipstrends-component with-title-with-slide">
        <WithTitle title={t('Tips & Trends')} backgroundColor="#131c4e">
          <Slider
            items={datas}
            uiRenderer={data => {
              const { id, image, title } = data;
              const full_file_path = `${getServiceUrl()}/${_.get(image, 'path')}`;
              return (
                <Link to={`/tips-trends/detail/${id}`}>
                  <div
                    style={{
                      height: 300,
                      borderRadius: 10
                    }}
                  >
                    <BackgroundImage image={full_file_path} />
                    <div className="title">{t(title)}</div>
                  </div>
                </Link>
              );
            }}
            settings={{
              slidesToShow: 3
            }}
          />
        </WithTitle>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/PopularTipsTrends.js